import _ from 'lodash';

import { createApiReducer } from 'src/api';

import {
  ADD_LOCATION_START,
  ADD_LOCATION_SUCCESS,
  ADD_LOCATION_FAILURE,
  UPDATE_LOCATION_START,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_LOCATION_FAILURE,
  SET_LOCATION_LICENSE_IMAGES_START,
  SET_LOCATION_LICENSE_IMAGES_SUCCESS,
  SET_LOCATION_LICENSE_IMAGES_FAILURE,
  DELETE_LOCATION_START,
  DELETE_LOCATION_SUCCESS,
  DELETE_LOCATION_FAILURE,
} from './actions';

export const transformLocation = response => ({
  id: response.id,
  address: response.location_address,
  address2: response.location_address_2,
  type: _.get(response, 'location_address_type.address_type_type'),
  typeId: _.get(response, 'location_address_type.id'),
  city: response.location_city,
  licenseExpiredDate: response.location_license_date_expired,
  licenseIssuedDate: response.location_license_date_issued,
  licenseImageFront: response.location_license_image_front,
  licenseImageBack: response.location_license_image_back,
  licenseNumber: response.location_license_number,
  licenseType: response.location_license_type,
  licenseCheckToggle: response.location_license_check,
  state: response.location_state,
  zipCode: response.location_zipcode,
  phoneNumber: response.location_phone_number,
  customerServicePhoneNumber: response.location_customer_service_number,
  dba: response.location_dba,
  email: response.location_email,
  facebook: response.location_facebook,
  linkedin: response.location_linkedin,
  twitter: response.location_twitter,
  instagram: response.location_instagram,
  consentURL: response.location_consent_url,
  licenseURL: response.location_license_url,
  apiKey: response.location_regulatory_api_key,
  location_notes: response.location_notes,
});

export const transformLocationLicenseImages = response => ({
  licenseImageFront: response.location_license_image_front,
  licenseImageBack: response.location_license_image_back,
});

const updateItem = (list, key, value, newItem) => {
  return list.map(item => {
    if (item[key] === value) {
      return newItem;
    }
    return item;
  });
};

const accountAddLocationReducer = createApiReducer(
  [ADD_LOCATION_START, ADD_LOCATION_SUCCESS, ADD_LOCATION_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      locations: [...state.data.locations, transformLocation(payload)],
    };
  },
  error => transformLocation(_.get(error, 'payload.response', {}))
);

const updateLocations = (payload, state) => {
  const newLocation = transformLocation(payload);

  return {
    ...state.data,
    locations: updateItem(
      state.data.locations,
      'id',
      newLocation.id,
      newLocation
    ),
  };
};

const accountUpdateLocationReducer = createApiReducer(
  [UPDATE_LOCATION_START, UPDATE_LOCATION_SUCCESS, UPDATE_LOCATION_FAILURE],
  updateLocations,
  error => transformLocation(_.get(error, 'payload.response', {}))
);

const accountSetLocationLicenseImagesReducer = createApiReducer(
  [
    SET_LOCATION_LICENSE_IMAGES_START,
    SET_LOCATION_LICENSE_IMAGES_SUCCESS,
    SET_LOCATION_LICENSE_IMAGES_FAILURE,
  ],
  updateLocations,
  error => transformLocationLicenseImages(_.get(error, 'payload.response', {}))
);

const accountDeleteLocationReducer = createApiReducer(
  [DELETE_LOCATION_START, DELETE_LOCATION_SUCCESS, DELETE_LOCATION_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      locations: state.data.locations.filter(l => l.id !== payload.id),
    };
  },
  error => transformLocationLicenseImages(_.get(error, 'payload.response', {}))
);

export const reducers = [
  accountAddLocationReducer,
  accountSetLocationLicenseImagesReducer,
  accountUpdateLocationReducer,
  accountDeleteLocationReducer,
];
